import React from 'react'
import ApiKeyComponent from './child/ApiKeyComponent'


const ApiGatewayLayer = () => {
    return (
        <div className="row gy-4">
            <ApiKeyComponent />
        </div>
    )
}

export default ApiGatewayLayer